import {
  CheckCircle,
  Info,
  Warning,
  WarningCircle,
} from '@phosphor-icons/react';
import { useToast } from '../../hooks/use-toast';
// Component Map › Toasts (sonner): a neutral surface; the icon carries the colour.
import {
  Toast,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from './toast';

const TOAST_ICON_BY_VARIANT = {
  default: Info,
  info: Info,
  success: CheckCircle,
  warning: Warning,
  destructive: WarningCircle,
} as const;

const TOAST_ICON_CLASS_BY_VARIANT = {
  default: 'text-muted-foreground',
  info: 'text-info',
  success: 'text-success',
  warning: 'text-warning',
  destructive: 'text-destructive',
} as const;

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider duration={2600}>
      {toasts.map(({ id, title, description, action, variant, ...props }) => {
        const resolvedVariant = variant ?? 'default';
        const Icon = TOAST_ICON_BY_VARIANT[resolvedVariant];

        return (
          <Toast key={id} variant={resolvedVariant} duration={2600} {...props}>
            <Icon
              className={`mt-0.5 size-4 shrink-0 ${TOAST_ICON_CLASS_BY_VARIANT[resolvedVariant]}`}
              aria-hidden
            />
            <div className="min-w-0 flex-1">
              {title ? (
                <ToastTitle className="text-sm font-medium leading-snug text-foreground">
                  {title}
                </ToastTitle>
              ) : null}
              {description ? (
                <ToastDescription className="mt-0.5 text-[13px] leading-snug text-muted-foreground">
                  {description}
                </ToastDescription>
              ) : null}
              {action}
            </div>
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
